export const FLOW_NAME_ENUM = {
  DISCONNECTION: 'Disconnection',
  LOSS_OF_SUPPLIER: 'Loss of Supplier',
  CHANGE_OF_METERING: 'Change of Metering',
  PSR_DETAILS_UPDATE: 'PSR Details Update',
  PSR_DETAILS_DELETE: 'PSR Details Delete',
  CHANGE_OF_SUPPLIER: 'Change of Supplier',
  ACQUISITION_PROCESS: 'Acquisition Process',
  CHANGE_OF_ENERGISATION: 'Change of Energisation',
  CONTACT_DETAILS_CHANGE: 'Contact Details Change',
  TRANSFER_OF_READS_LOSING: 'Transfer Of Reads Losing',
  DATA_SERVICE_APPOINTMENT: 'Data Service Appointment',
  TRANSFER_OF_READS_GAINING: 'Transfer Of Reads Gaining',
  ANNUAL_CONSUMPTION_CHANGE: 'Annual Consumption Change',
  METERING_SERVICE_APPOINTMENT: 'Metering Service Appointment',
  CHANGE_OF_REG_DETAILS_SMSO_CHANGE: 'Change of Reg Details SMSOChange',
  CHANGE_OF_REG_DETAILS_ADDRESS_CHANGE: 'Change of Reg Details AddressChange',
  CHANGE_OF_REG_DETAILS_LINKED_MPAN_ADD: 'Change of Reg Details LinkedMPANAdd',
  CHANGE_OF_REG_DETAILS_RELATED_MPAN_ADD: 'Change of Reg Details RelatedMPANAdd',
  CHANGE_OF_REG_DETAILS_IHD_STATUS_CHANGE: 'Change of Reg Details IHDStatusChange',
  CHANGE_OF_REG_DETAILS_LINKED_MPAN_CREATE: 'Change of Reg Details LinkedMPANCreate',
  CHANGE_OF_REG_DETAILS_RELATED_MPAN_CREATE: 'Change of Reg Details RelatedMPANCreate',
  CHANGE_OF_REG_DETAILS_RELATED_MPAN_REMOVE: 'Change of Reg Details RelatedMPANRemove',
  CHANGE_OF_REG_DETAILS__LINKED_MPAN_REMOVE: 'Change of Reg Details LinkedMPANRemove',
  CHANGE_OF_REG_DETAILS_DOM_INDICATOR_CHANGE: 'Change of Reg Details DomIndicatorChange',
  CHANGE_OF_REG_DETAILS_CONSENT_GRANULARITY_CHANGE: 'Change of Reg Details ConsentGranularityChange',
  CONSUMPTION_AMENDMENT: 'Consumption Amendment',
};

export const STEP_STATUS_ENUM = {
  NO_OBJECTION: 'NoObjection',
  OBJECTION: 'Objection',
  ANNULMENT: 'Annulment',
  INTERRUPTED: 'Interrupted',
  PENDING: 'Pending',
  SECURED_ACTIVE: 'Secured Active',
  FAILED: 'Failed',
  SUCCESS: 'Success',
  CANCELLED: 'Cancelled',
  ACTIVE: 'Active',
};

export const INITIATED_BY_ENUM = {
  US: 'Us',
  THIRD_PARTY: 'Third Party',
};